<div id="contactInformationContainer">
  <div style="display: flex; align-items: start; gap: 10px; justify-content: space-between;">
    <div>
      <h2 class="cpo-section-title">Contacts</h2>
    </div>
    @if (this.enableEditing) {
      <div [hidden]="editingContact || !contacts?.length">
        <span class="cpo-edit-link" (click)="btnEdit_click(c)">Edit</span>
      </div>
      <div [hidden]="!editingContact">
        <span class="cpo-edit-link" (click)="editingContact = false">Done</span>
      </div>
    } 
  </div>

  @if (savingContacts) {
    <h1>Saving Contacts...</h1>
  } @else {
    <div style="display: flex; align-items: stretch; justify-content: space-between; flex-wrap: wrap;">
      @for (c of contacts; track c) {
        <div
          style="
            flex: 1;
            padding: 0px 0px 10px 30px;
          "
        >
          <div class="cpo-pod" style="max-width: fit-content;">
            <div style="display: flex; align-items: center; gap: 10px; justify-content: space-between;">
              <div style="display: flex; flex-direction: column; gap: 5px;">
                <span class="title" style="padding:0px;">{{ c.contactTypes.join(', ') }}</span>
                <span class="r1">{{ c.firstName }} {{ c.lastName }}</span>
              </div>
              <div style="display: flex; align-items: center; gap: 10px;">
                <app-icon style="cursor: pointer;" title="Edit Contact" [color]="'var(--color-action-icon)'"
                (click)="editContact(c)" type="Edit" [hidden]="!editingContact"></app-icon>
                <app-icon style="cursor: pointer;" title="Delete contact" [color]="'var(--color-action-icon-delete)'"
                (click)="handleRemoveContact(c)" type="Trash" [hidden]="!editingContact"></app-icon>
              </div>
            </div>
            <div class="r2">
              <span style="text-decoration: underline; text-underline-offset: 2px;">{{ c.emailAddress }}</span>
              <svg width="16" height="16" style="margin-left: 3px; margin-right: 3px;">
                <circle cx="8" cy="13" r="2" fill="var(--green-900)" />
              </svg>
              <span style="text-decoration: underline; text-underline-offset: 2px;">{{ c.phone?.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3') }}</span>
            </div>
          </div>
        </div>
      }
    </div>
    @if (this.enableEditing) {
      <input
        type="button"
        value="Add Contact"
        class="btn-core toolbar-button"
        style="height: 37px; margin: 0px; width: 100%;"
        (click)="addContact()"
      />
    }
  }
</div>
